// Cart-only additions; the theme retains its existing product forms and cart events.
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('#mini-cart [data-jg-add]')) return;
  event.preventDefault();
  if (form.dataset.busy === 'true') return;
  const button = form.querySelector('button');
  const status = form.closest('.jg-suggestions')?.querySelector('.jg-add-status');
  form.dataset.busy = 'true';
  if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
  if (status) status.textContent = '';
  try {
    const body = new FormData(form);
    body.set('sections', 'mini-cart');
    body.set('sections_url', window.location.pathname);
    const addUrl = window.themeVariables.routes.cartAddUrl;
    const response = await fetch(`${addUrl}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'Produkten kunde inte läggas till. Försök igen.');
    let cart;
    try {
      const response = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
      if (response.ok) cart = await response.json();
    } catch { /* Still request a fresh cart section if the count request fails. */ }
    if (cart) {
      cart.sections = result.sections;
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, replacementDelay: 0 } }));
  } catch (error) {
    if (status) status.textContent = error.message || 'Något gick fel. Försök igen.';
  } finally {
    delete form.dataset.busy;
    if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
  }
});

const syncJgViewport = () => {
  const drawer = document.getElementById('mini-cart');
  if (!drawer?.classList.contains('jg-cart')) return;
  // Dynamic viewport units include Safari's changing browser bars without leaving a gap.
  if (CSS.supports('height', '100dvh')) drawer.style.removeProperty('--jg-height');
  else drawer.style.setProperty('--jg-height', `${window.innerHeight}px`);
};
syncJgViewport();
window.addEventListener('resize', syncJgViewport);
window.visualViewport?.addEventListener('resize', syncJgViewport);
document.addEventListener('openable-element:open', syncJgViewport);

// Native swipe scrolling also works without JavaScript; controls enhance it.
class JgCartCarousel extends HTMLElement {
  frame = 0;
  current = 0;
  resizeObserver = new ResizeObserver(() => this.queueUpdate());
  contentObserver = new MutationObserver(() => this.queueUpdate());

  connectedCallback() {
    this.addEventListener('click', this.onClick);
    this.addEventListener('scroll', this.onScroll, true);
    this.resizeObserver.observe(this);
    this.contentObserver.observe(this, { childList: true, subtree: true });
    this.queueUpdate();
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('scroll', this.onScroll, true);
    this.resizeObserver.disconnect();
    this.contentObserver.disconnect();
    cancelAnimationFrame(this.frame);
  }
  onScroll = () => this.queueUpdate();
  queueUpdate() {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.update());
  }
  update() {
    const track = this.querySelector('.jg-slider-track');
    const cards = [...this.querySelectorAll('.jg-suggestion')];
    if (!track || !cards.length) return;
    const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
    const max = track.scrollWidth - track.clientWidth;
    this.current = max > 1 && track.scrollLeft >= max - 2 ? cards.length - 1 : Math.round(track.scrollLeft / Math.max(1, step));
    this.querySelectorAll('[data-jg-slide-to]').forEach((dot, i) => {
      if (i === this.current) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    const prev = this.querySelector('[data-jg-slide-prev]');
    const next = this.querySelector('[data-jg-slide-next]');
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = max <= 1 || track.scrollLeft >= max - 2;
  }
  onClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-jg-slide-prev], [data-jg-slide-next], [data-jg-slide-to]');
    if (!button) return;
    const track = this.querySelector('.jg-slider-track');
    const cards = [...this.querySelectorAll('.jg-suggestion')];
    if (!track || !cards.length) return;
    let target = this.current;
    if (button.hasAttribute('data-jg-slide-prev')) target--;
    if (button.hasAttribute('data-jg-slide-next')) target++;
    if (button.hasAttribute('data-jg-slide-to')) target = Number(button.dataset.jgSlideTo);
    target = Math.min(cards.length - 1, Math.max(0, target));
    track.scrollTo({ left: cards[target].offsetLeft - cards[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  };
}
if (!customElements.get('jg-cart-carousel')) customElements.define('jg-cart-carousel', JgCartCarousel);

// The cart overlay belongs to this drawer only.
document.addEventListener('click', event => {
  if (event.target instanceof Element && event.target.matches('#mini-cart.jg-cart > .drawer__overlay')) document.getElementById('mini-cart').open = false;
});
